export default {
  TYPES_EMPLOYEES: [
    { KEY: 0, VALUE: 'MOTORISTA' },
    { KEY: 1, VALUE: 'COBRADOR' },
    { KEY: 2, VALUE: 'ENCARREGADO' },
  ],
  TYPES_LICENSES: [
    { KEY: 'A', VALUE: 'A' },
    { KEY: 'B', VALUE: 'B' },
    { KEY: 'C', VALUE: 'C' },
    { KEY: 'D', VALUE: 'D' },
    { KEY: 'E', VALUE: 'E' },
  ],
  TYPES_DRIVERS: [
    { KEY: 'Normal', VALUE: 'Normal' },
    { KEY: 'Teste', VALUE: 'Teste' },
  ],
  TYPES_INCHARGE: [
    { KEY: 'Normal', VALUE: 'Normal' },
    { KEY: 'Teste', VALUE: 'Teste' },
  ],
  TABLE_HEADER: new Map([
    ['Perfil Comum', 'Perfil Comum'],
    ['Externa', 'Externa'],
    ['Nova politica', 'Nova politica'],
    ['Politica de teste', 'Politica de teste'],
    ['total', 'Valor total'],
    ['comission', 'Comissão'],
    ['undefined', 'Valor'],
    ['Pagantes', 'Pagantes'],
  ]),
  STATUS: [
    { KEY: 0, VALUE: 'ATIVO' },
    { KEY: 1, VALUE: 'INATIVO' },
    { KEY: 2, VALUE: 'BLOQUEADO' },
  ],
};

const CONST_EMPLOYEES_OBJECT = {
  TYPES_EMPLOYEES: {
    DRIVER: { KEY: 0, VALUE: 'MOTORISTA' },
    TICKET_COLLECTOR: { KEY: 1, VALUE: 'COBRADOR' },
    IN_CHARGE: { KEY: 2, VALUE: 'ENCARREGADO' },
  },
};

const PERIOD_WITHOUT_TRANSFER = [
  { LABEL: 'dia', VALUE: 86400 }, // 1 day
  { LABEL: 'semana', VALUE: 604800 }, // 1 week
  { LABEL: 'mes', VALUE: 2592000 }, // 1  month
];

const COMISSION_TYPES = [
  { LABEL: 'Porcentagem', VALUE: 0 },
  { LABEL: 'Valor Fixo', VALUE: 1 },
];

const COMISSION_PAYMENT_RULE = [
  { LABEL: 'Descontado na Hora', VALUE: 0 },
  { LABEL: 'Pago posteriormente', VALUE: 1 },
];
const COMISSION_PAYMENT_RULE_TYPE = {
  AT_PAYMENT_TIME: 0,
  POST_PAYMENT: 1,
};

export {
  CONST_EMPLOYEES_OBJECT,
  PERIOD_WITHOUT_TRANSFER,
  COMISSION_TYPES,
  COMISSION_PAYMENT_RULE,
  COMISSION_PAYMENT_RULE_TYPE,
};
